/* eslint-disable no-unused-vars */
import echarts from 'echarts/lib/echarts'
/* import { legend } from 'echarts/lib/theme/dark' */
const myMixinfault = {
  mounted: function () {

  },
  data () {
    return {

    }
  },
  watch: {
  },
  methods: {
    formatDate (date, flag) {
      var y = date.getFullYear()
      var m = date.getMonth()
      m = m + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var hh = date.getHours()
      hh = hh < 10 ? ('0' + hh) : hh
      var mm = date.getMinutes()
      mm = mm < 10 ? ('0' + mm) : mm
      var ss = date.getSeconds()
      ss = ss < 10 ? ('0' + ss) : ss
      return y + '/' + m + '/' + d + ' ' + hh + ':' + mm + ':' + ss
    },
    drawLine_aa () {
      let vm = this
      //console.log(vm.listData.aBavolArr)
      // 为charts选定父容器并初始化charts画布
      let myChart = vm.$echarts.init(document.getElementById('chart1'))

      // 为图表添加数据
      myChart.setOption({
        color: ['#F5B73F', '#3FBD8C', '#DD5247'],
        // title: {
        //   text: '杆塔工频电流'
        // },
        axisPointer: {
          link: [
            {
              // 表示所有 xAxisIndex 为 0、3、4 和 yAxisName 为 'someName' 的坐标轴联动。
              xAxisIndex: [0],
              yAxisName: '电压：V'
            }
            // {
            //   // 表示左右 xAxisId 为 'aa'、'cc' 以及所有的 angleAxis 联动。
            //   xAxisId: ['aa', 'cc'],
            //   angleAxis: 'all'
            // }
          ]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            triggerOn: 'mousemove',
            lineStyle: {
              color: '#5A5A5A',
              width: 1,
              type: 'dash'
            }
          },
          backgroundColor: 'transparent',
          formatter: function (params) {
            // console.log(params)
            vm.item1 = params
            // var res = params[0].axisValue + '<br>'
            var res = '<span style="color:transparent;">' + vm.formatDate(new Date(params[0].axisValue)) + '/span><br/>'
            vm.defaultTime1 = vm.formatDate(new Date(params[0].axisValue))
            // params.forEach(function (item) {
            //   res += item.marker + item.seriesName + ' : ' + '<span>' + item.data[1] + 'V</span><br>'
            // })
            return res
          }
        },
        grid: {
          left: 15,
          right: 25,
          top: 25,
          bottom: 20,
          containLabel: true
        },
        dataZoom: [{
          type: 'inside', // slider鼠标滚动可缩放inside
          start: 0,
          end: 100
        }],
        // legend: {
        //   top: '0%',
        //   itemWidth: 15,
        //   itemHeight: 8,
        //   textStyle: {
        //     color: '#303030',
        //     fontSize: 12
        //   },
        //   icon: 'circle',
        //   itemGap: 30,
        //   data: ['A相', 'B相', 'C相']
        // },

        xAxis: {
          type: 'time',
          min: function (value) {
            var min = value.min
            if (value.min === value.max) {
              min = value.min - 1800000
            }
            return min
          },
          max: function (value) {
            var max = value.max
            if (value.min === value.max) {
              max = value.max + 1800000
            }
            return max
          },
          splitLine: {
            show: false
          },
          // type: 'value',
          // name: '时间us',
          // nameTextStyle: { // 小标题颜色
          //   color: '#6A6A6A',
          //   fontSize: 12,
          //   align: 'center'

          // },
          // minInterval: 1, // 保证坐标轴分割刻度显示成整数
          boundaryGap: false,
          // data: ['0', '120', '200', '220', '400', '350', '600', '630', '800', '730', '1000', '1050', '1200', '1240', '1400',
          //   '1550', '1600', '1710', '1800'
          // ],
          axisLine: {
            lineStyle: {
              color: '#CDD4DA'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
            inside: false
          },
          axisLabel: {
            interval: 'auto',
            show: true,
            // splitNumber: 15,
            textStyle: {
              fontSize: 12,
              color: '#2D2D2D'
            },
            formatter: function (value) {
              var date = new Date(value)
              var time = vm.formatDate(date)
              return time.substr(5, 5) + '\n' + time.substr(11, 5)// 自定义x轴显示
            }
            // formatter: function (params) {
            //   return params.split(' ')[0] + '\n' + params.split(' ')[1]
            // }
          }
        },
        yAxis: {
          type: 'value',
          name: '电压：V',
          interval: 'auto', // 1000, // y轴数值间隔
          // min: -20,
          // max: 40,
          nameTextStyle: { // 小标题颜色
            color: '#A1A1A1',
            fontSize: 11,
            padding: [-8, 0, -5, 20]
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} ',
            textStyle: {
              fontSize: 12,
              color: '#2D2D2D'
            }

          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          show: true
        },
        series: [{
          name: 'A相',
          type: 'line',
          symbol: 'none', // 去掉线上圆点
          smooth: true, // true:平滑曲线  , false:折线
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1.4 // 设置折线粗细
              }
            }
          },
          data: vm.listData.aBavolArr,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线。
            onZero: true // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            // onZeroAxisIndex: 0, //当有双轴时，可以用这个属性手动指定，在哪个轴的 0 刻度上。
          }
        },
        {
          name: 'B相',
          type: 'line',
          // min: 0,
          symbol: 'none', // 去掉线上圆点
          smooth: true, // true:平滑曲线  , false:折线
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1 // 设置折线粗细
              }
            }
          },
          data: vm.listData.bBavolArr,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线。
            onZero: true, // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            onZeroAxisIndex: 0 // 当有双轴时，可以用这个属性手动指定，在哪个轴的 0 刻度上。
          }
        },
        {
          name: 'C相',
          type: 'line',
          // min: 0,
          symbol: 'none', // 去掉线上圆点
          smooth: true, // true:平滑曲线  , false:折线
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1 // 设置折线粗细
              }
            }
          },
          data: vm.listData.cBavolArr,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线。
            onZero: true, // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            onZeroAxisIndex: 0 // 当有双轴时，可以用这个属性手动指定，在哪个轴的 0 刻度上。
          }
        }
        ]
      })
    },
    drawLine_bb () {
      let vm = this
      // 为charts选定父容器并初始化charts画布
      let myChart = vm.$echarts.init(document.getElementById('chart2'))

      // 为图表添加数据
      myChart.setOption({
        color: ['#F5B73F', '#3FBD8C', '#DD5247'],
        // title: {
        //   text: '杆塔工频电流'
        // },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'transparent',
          formatter: function (params) {
            vm.item2 = params
            // var res = vm.formatDate(new Date(params[0].axisValue)) + '<br/>'
            var res = '<span style="color:transparent;">' + vm.formatDate(new Date(params[0].axisValue)) + '/span><br/>'
            vm.defaultTime2 = vm.formatDate(new Date(params[0].axisValue))
            // params.forEach(function (item) {
            //   res += item.marker + item.seriesName + ' : ' + '<span>' + item.data[1] + 'A</span><br>'
            // })
            return res
          },
          axisPointer: {
            lineStyle: {
              color: '#5A5A5A',
              width: 1,
              type: 'dash'
            }
          }
        },
        grid: {
          left: 15,
          right: 25,
          top: 25,
          bottom: 20,
          containLabel: true
        },
        dataZoom: [{
          type: 'inside', // slider鼠标滚动可缩放inside
          start: 0,
          end: 100
        }],
        // legend: {
        //   top: '0%',
        //   itemWidth: 15,
        //   itemHeight: 8,
        //   textStyle: {
        //     color: '#303030',
        //     fontSize: 12
        //   },
        //   icon: 'circle',
        //   itemGap: 30,
        //   data: ['A相', 'B相', 'C相']
        // },

        xAxis: {
          type: 'time',
          // type: 'value',
          // name: '时间us',
          // nameTextStyle: { // 小标题颜色
          //   color: '#6A6A6A',
          //   fontSize: 12,
          //   align: 'center'

          // },
          // minInterval: 1, // 保证坐标轴分割刻度显示成整数
          boundaryGap: false,
          min: function (value) {
            var min = value.min
            if (value.min === value.max) {
              min = value.min - 1800000
            };
            return min
          },
          max: function (value) {
            var max = value.max
            if (value.min === value.max) {
              max = value.max + 1800000
            }
            return max
          },
          splitLine: {
            show: false
          },
          // data: ['0', '120', '200', '220', '400', '350', '600', '630', '800', '730', '1000', '1050', '1200', '1240', '1400',
          //   '1550', '1600', '1710', '1800'
          // ],
          axisLine: {
            lineStyle: {
              color: '#CDD4DA'
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
            inside: false
          },
          axisLabel: {
            interval: 'auto',
            show: true,
            // splitNumber: 15,
            textStyle: {
              fontSize: 12,
              color: '#2D2D2D'
            },
            formatter: function (value) {
              var date = new Date(value)
              var time = vm.formatDate(date)
              return time.substr(5, 5) + '\n' + time.substr(11, 5)// 自定义x轴显示
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '电流：A',
          interval: 'auto', // 1000, // y轴数值间隔
          // min: -20,
          // max: 40,
          nameTextStyle: { // 小标题颜色
            color: '#A1A1A1',
            fontSize: 11,
            padding: [-8, 0, -5, 20]
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value} ',
            textStyle: {
              fontSize: 12,
              color: '#2D2D2D'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          show: true
        },
        series: [{
          name: 'A相',
          type: 'line',
          symbol: 'none', // 去掉线上圆点
          smooth: true, // true:平滑曲线  , false:折线
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1.4 // 设置折线粗细
              }
            }
          },
          data: vm.listData.aloadcurArr,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线。
            onZero: true // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            // onZeroAxisIndex: 0, //当有双轴时，可以用这个属性手动指定，在哪个轴的 0 刻度上。
          }
        },
        {
          name: 'B相',
          type: 'line',
          min: 0,
          symbol: 'none', // 去掉线上圆点
          smooth: true, // true:平滑曲线  , false:折线
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1 // 设置折线粗细
              }
            }
          },
          data: vm.listData.bloadcurArr,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线。
            onZero: true, // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            onZeroAxisIndex: 0 // 当有双轴时，可以用这个属性手动指定，在哪个轴的 0 刻度上。
          }
        },
        {
          name: 'C相',
          type: 'line',
          min: 0,
          symbol: 'none', // 去掉线上圆点
          smooth: true, // true:平滑曲线  , false:折线
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 1 // 设置折线粗细
              }
            }
          },
          data: vm.listData.cloadcurArr,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#ecebeb'
            }
          },
          axisLine: {
            show: true, // 是否显示坐标轴轴线。
            onZero: true, // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            onZeroAxisIndex: 0 // 当有双轴时，可以用这个属性手动指定，在哪个轴的 0 刻度上。
          }
        }
        ]
      })
    }
  }
}
export default myMixinfault
